export const STATUS_COLOR = {
  OK: '#7ECF42',
  WARNING: '#EB6E19',
  CRITICAL: '#A9A9A9',
  'Continuous Monitoring': '#04B0ED',
  'Baseline Incomplete': '#F1C40F',
  'Blackout in progress': '#E74C3C',
  'Awaiting Verification': '#F1C40F',
  Archived: '#595959'
};

export const URL_HEALTH_STATUSES = {
  OK: {
    color: '#7ECF42',
    desc: 'The webpage matches with the original baseline. No changes have been detected.',
    isCheckChangesDetected: false,
    isCheckAlert: false,
    isCheckMonitor: true,
    isCheckRebase: false
  },
  WARNING: {
    color: '#EB6E19',
    desc: 'The webpage differs from the original baseline. An additional check will be done before alerts are sent out.',
    isCheckChangesDetected: true,
    isCheckAlert: false,
    isCheckMonitor: true,
    isCheckRebase: false
  },
  CRITICAL: {
    color: '#A9A9A9',
    desc: 'The webpage differs from the original baseline. Alerts have been sent to users for verification. Re-baseline is required for subsequent alerts to be sent.',
    isCheckChangesDetected: true,
    isCheckAlert: true,
    isCheckMonitor: false,
    isCheckRebase: true
  },
  'Continuous Monitoring': {
    color: '#04B0ED',
    desc: 'The webpage differs from the original baseline. Alerts have been sent for the previous change. Auto-rebaseline is activated and alerts for subsequent changes will still be sent without re-baseline. Manual re-baseline is optional to reset the Health Status to OK.',
    isCheckChangesDetected: true,
    isCheckAlert: true,
    isCheckMonitor: true,
    isCheckRebase: false
  },
  'Baseline Incomplete': {
    color: '#F1C40F',
    desc: '',
    isCheckChangesDetected: false,
    isCheckAlert: false,
    isCheckMonitor: false,
    isCheckRebase: false
  },
  'Blackout in progress': {
    color: '#E74C3C',
    desc: '',
    isCheckChangesDetected: false,
    isCheckAlert: false,
    isCheckMonitor: false,
    isCheckRebase: false
  },
  'Awaiting Verification': {
    color: '#F1C40F',
    desc: '',
    isCheckChangesDetected: false,
    isCheckAlert: false,
    isCheckMonitor: false,
    isCheckRebase: false
  },
  Archived: {
    color: '#595959',
    desc: 'The webpage is archived. Monitoring has stopped and the plan slot is freed, but alerts and policies are kept for audit purposes until the record is removed.',
    isCheckChangesDetected: false,
    isCheckAlert: false,
    isCheckMonitor: false,
    isCheckRebase: false
  }
};
